import { faRotateRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./styles.module.css";

export default function ErrorMessage({
  message = "Could not load data",
  onReload,
}) {
  return (
    <div className={styles.container}>
      <p className={styles.message}>{message}</p>
      <button
        className={styles.reloadButton}
        onClick={() => onReload()}
        aria-label="Reload"
      >
        <FontAwesomeIcon icon={faRotateRight} />
      </button>
    </div>
  );
}
